// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "io.novawallet",
    name: "Nova Wallet",
    homepage: "https://novawallet.io",
    image_id: "4f159b10-419b-483a-f2bf-da3d17855e00",
    app: {
        browser: null,
        ios: "https://apps.apple.com/app/nova-polkadot-kusama-wallet/id1597119355",
        android: "https://play.google.com/store/apps/details?id=io.novafoundation.nova.market",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "novawallet://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map